export default "__VITE_ASSET__CYmCtW6M__"